// extracted by mini-css-extract-plugin
export var fullGrid = "_3n-3";
export var pdpPreviewContainer = "_3n-1";
export var previewContainer = "_3n-0";
export var togglePreviewContainer = "_3n-2";